<template>
  <div>
    <v-card v-show="showChart" cols="12">
      <div class="px-2 pt-4">
        <div class="mx-2 mb-3">
          <!-- <div class="mb-4 subheading">
            <span v-if="canExportInactivePlayers">
              Download:
            </span>
          </div>
          <v-checkbox
            v-if="
              canExportInactivePlayers &&
                canExportInactivePlayersWithTransactions
            "
            v-model="exportWithTransactions"
            :label="$t('withTransactions')"
          /> -->
          <GroupExport :hideExport="!canExportInactivePlayers" />
        </div>
      </div>
      <div class="text-center">
        <div class="pt-4 pb-2">
          {{ $t("from") }}: {{ date.from }} - {{ $t("until") }}: {{ date.to }}
        </div>
      </div>
      <v-divider></v-divider>
      <v-row>
        <v-col>
          <div class="pa-6">
            <PieChart :data="data" :type="'playersInactive'" />
            <div>
              <div class="text-right mb-1">
                <span>
                  {{ $t("actives") }}:
                  <v-chip small color="green darken-2"
                    >{{ data.active }}
                  </v-chip></span
                >
              </div>
              <div class="text-right">
                <span>
                  {{ $t("inactives") }}:
                  <v-chip small color="red darken-2">
                    {{ data.inactive }}
                  </v-chip>
                </span>
              </div>
              <div class="caption text-right mt-1 text--rey">
                {{ $t("inactivesPlayersMsg") }}
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- Apostas Pendentes -->
    </v-card>
    <div class="text-center">
      <h3 v-show="!showChart">
        {{ $t("noDataForthisQuery") }}
      </h3>
    </div>
  </div>
</template>
<script>
import PieChart from "@/components/Charts/PieChart";
import GroupExport from "@/components/common/filters/GroupExport.vue";
export default {
  components: {
    PieChart,
    GroupExport,
  },
  data: () => ({
    data: {
      dados: {},
      range: {
        from: "",
        to: "",
      },
    },
    headers: [],
    search: "",
    showChart: true,
    date_start: "",
    data_final: "",
    range: {},
    titleDate: {
      data_inicio: "",
      data_final: "",
    },
    date: {
      to: "",
      from: "",
    },
    exportWithTransactions: false,
  }),
  mounted() {
    this.getData();
  },
  computed: {
    exportDoc() {
      return this.$store.state.filters.groupExport.value;
    },
    rangeDate() {
      return this.$store.state.range.date;
    },
    canExportInactivePlayersWithTransactions() {
      return this.$permission("31");
    },
    canExportInactivePlayers() {
      return this.$permission("33");
    },
  },
  watch: {
    exportDoc(val) {
      if (!val) return;
      this.exportInactives();
    },
  },

  methods: {
    getData() {
      this.$request
        .get("/colab/players/onlinePlayerDistribution")
        .then((response) => {
          this.data = response.dados;
          this.date.from = new Date(this.data.range.from.replace(" ", "T"))
            .toLocaleString()
            .slice(0, -9);
          this.date.to = new Date(this.data.range.to.replace(" ", "T"))
            .toLocaleString()
            .slice(0, -9);

          //UI for Title in Download
          this.titleDate.data_final = this.data.range.to.replace(" ", "T");
          this.titleDate.data_inicio = this.data.range.from.replace(" ", "T");
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportInactives() {
      const endpoint = this.exportWithTransactions
        ? "/colab/players/exportInactivePlayersWithTransactions"
        : "/colab/players/exportInactiveOnlinePlayers";

      this.$request
        .exportDoc(
          endpoint,
          {
            export: this.exportDoc,
          },
          this.exportDoc,
          this.titleDate
        )

        .catch((error) => {
          console.log(error);
        })
        .finally(() => this.$store.commit("setGroupExport", ""));
    },
  },
};
</script>
